import styled from 'styled-components';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const Container = styled.div`
  border-top: 2px solid #666;
  padding: 15px 0;
`;
const Heading = styled.h2`
  margin-top: 0;
  font-weight: 600;
  padding-bottom: 13px;
  font-size: 14px;
  border-bottom: 1px solid #eee;
  margin-bottom: 0;
`;

const Form = styled.div`
  margin: 15px 0;

  margin-top: 25px;
  margin-bottom: 25px;
`;

const Submit = styled.div`
  text-align: center;
`;

const CardsWrapper = styled.div`
  border-top: 2px solid #666;
  h3.error {
    color: red;
  }
`;

const CardField = styled.div`
  > div {
    margin-bottom: 15px;
  }
`;

const Footer = styled.div`
  button {
    background-color: black;
    font-size: 16px;
    border-radius: 6px;
    padding: 12px;
    line-height: 1.5;
    color: rgb(255, 255, 255);
    width: 100%;
    text-transform: capitalize;
    box-shadow: none;
    :hover {
      background-color: black;
      color: rgb(255, 255, 255);
    }
  }
`;

const Cvv = styled.div`
  display: flex;
  grid-gap: 15px;
`;

const AddCardWrapper = styled.div`
  padding: 0 30px 30px 30px;
  position: relative;
  h2 {
    color: #000000;
    text-align: center;
    margin: 20px 0;
  }
`;

const StyledCloseIcon = styled(CloseIcon)`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  :hover {
    opacity: 0.5;
  }
`;

const AddCardButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  button {
    background-color: rgb(40, 57, 72);
    font-size: 14px;
    border-radius: 3px;
    padding: 12px;
    line-height: 1.5;
    color: rgb(255, 255, 255);
    width: 190px;
    :hover {
      background-color: rgb(40, 57, 72);
      color: rgb(255, 255, 255);
    }
  }
`;

const CardContainer = styled.div`
  display: flex;
  align-items: center;
`;

const CardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border: 1px solid ${(props) => (props?.selected ? 'green' : '#ccc')};
  border-radius: 5px;
  padding: 5px 10px;
  align-items: center;
  margin-bottom: 10px;
  flex: 1;
  margin-top: 12px;
  background-color: white;
  position: relative;
`;

const SuccessIcon = styled(CheckCircleIcon)`
  position: absolute;
  right: -8px;
  top: -8px;
  color: green;
  border-radius: 50%;
  background-color: white;
`;

const DeleteCard = styled.div`
  margin-left: 10px;
  cursor: pointer;
  svg {
    color: red;
  }
`;

const TextSection = styled.div`
  .add-payment {
    button {
      background-color: black;
      font-size: 16px;
      border-radius: 6px;
      padding: 12px;
      line-height: 1.5;
      color: rgb(255, 255, 255);
      width: 100%;
      text-transform: capitalize;
      box-shadow: none;
    }
  }
`;

const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  span.title {
    font-size: 14px;
  }
`;

const Instructions = styled.div`
  h2 {
    margin-top: 0;
    margin-bottom: 10px;
  }
  ul {
    padding-left: 16px;
    border-top: 1px solid #cccccc;
    margin: 0;
    padding-top: 20px;
  }
  table {
    border-collapse: collapse;
    width: 100%;
    margin: 10px 0;
  }

  td,
  th {
    border: 1px solid #ccc;
    text-align: left;
    padding: 8px;
  }

  div.delete-checkbox {
    border-top: 1px solid #cccccc;
    padding-top: 20px;

    p {
      color: red;
    }
  }
`;

const NoCardFound = styled.p`
  color: red;

  font-size: 14px;
  margin: 0 0 20px 0;
`;

const CardInstructions = styled.p`
  font-family: 'Inter600';
  font-size: 14px;
  margin: 0;
`;

export {
  CardInstructions,
  TextSection,
  SwitchWrapper,
  Instructions,
  NoCardFound,
  DeleteCard,
  SuccessIcon,
  Container,
  Heading,
  Form,
  Submit,
  CardsWrapper,
  AddCardWrapper,
  CardField,
  Footer,
  Cvv,
  StyledCloseIcon,
  AddCardButtonWrapper,
  CardContainer,
  CardWrapper,
};
